export { getServerSideProps } from 'views/search-results/get-server-side-props'
export { SearchResultsPage as default } from 'views/search-results/SearchResultsPage'
